import React, { useCallback } from 'react';
import { Popover } from '@barges/react';
import { linkType, useGeneralPopup, dismissPopup } from '../../hooks/useGeneralPopup';
import { downloadAppLink } from '../../../common/config/utils';
import classes from './classes.module.scss';

function GeneralPopup({ t, url }) {
  const { show, title, link } = useGeneralPopup();

  const onClicked = useCallback(() => {
    dismissPopup();
  }, []);

  const appLinkAFChanel = () => {
    switch (link) {
      case linkType.videoNotSupported:
        return 'video_button';
      case linkType.voiceNotSupported:
        return 'voice_button';
      case linkType.notificationNotSupported:
        return 'no_notification_support';
      default:
        return null;
    }
  };
  const appLink = (
    <a href={ downloadAppLink({ afChanel: appLinkAFChanel(), url }) } target="_blank" rel="noopener noreferrer" className={ classes.link }>
      { t('app_general.download_link') }
    </a>
  );

  const renderLink = () => {
    if (!link) return null;
    switch (link) {
      case linkType.videoNotSupported:
      case linkType.voiceNotSupported:
        return (
          <div>
            { t('general.this_feature_is_not_supported_yet') }
            { appLink }
            { `for ${ link === linkType.videoNotSupported ? 'video' : 'voice' } call.`}
          </div>
        );
      case linkType.notificationNotSupported:
        return (
          <div>
            { t('general.this_feature_is_not_supported_in_this_browser') }
            { appLink }
          </div>
        );
      default:
        return null;
    }
  };

  const renderGeneralPopupContent = () => (
    <div className={ classes.generalPopupContentContainer }>
      <div className={ classes.title }>
        { title }
        { renderLink() }
      </div>
      <div className={ classes.okBtnContainer }>
        <button type="button" className={ classes.okBtn } onClick={ onClicked } key="ok_button">
          {t('general.ok')}
        </button>
      </div>
    </div>
  );

  const renderGeneralPopup = () => (
    <Popover
      isOpen={ show }
      centered
      onCloseButtonClick={ onClicked }
      closable
      className={ classes.generalPopupPopover }
    >
      { renderGeneralPopupContent() }
    </Popover>
  );

  return  renderGeneralPopup();
}

export default GeneralPopup;
